
import Vue from "vue";
import {AuthService, UserConfigService} from "@/services";
import {SaleEditState} from "@/utils/sale-edit/sale-edit-state";
import { printHumanFloat } from "../../utils/pretty-print";
import AppCashierSaleSettings from "@/components/cashier/CashierSaleSettings.vue";
import AppCashierAddDiverse from "@/components/cashier/CashierAddDiverse.vue";
import AppCashierKeyPad from "@/components/cashier/CashierKeyPad.vue";
import {MODULE} from "@/config/modules";
import {Sale, SaleRow} from "@/models/base";
import AppTicketRefundModal from "@/components/cashier/TicketRefundModal.vue";

export default Vue.extend({
	filters: {
		printHumanFloat
	},
	data(){
		return {
			displayID: "",
			openEditSaleSettings: false,
			openAddDiverse: false,
			keyPadOpen: true,
			diverseAmount: 0,
			activeCashier: 1,
			storage: [] as [] | Sale[],
			fetching: false,
			scrollKey: 1
		};
	},
	props: {
		state: {
			type: Object as () => SaleEditState,
			required: true
		}
	},
	computed: {
		bodyHeight():string{
			let n = 240;
			if(this.keyPadOpen){
				n = n + 220; // keypad heigt + padding bottom
			}
			return "calc(100vh - "+n+"px)";
		}
	},
	watch: {
		"state.sale.Rows.length"(){
			this.scrollBottom();
			this.state.selectedRow = this.state.sale.Rows.slice(-1)[0];
			this.saveStorage();
		},
		"state.sale.TotalIncVAT"(){
			if(!this.fetching){
				this.saveStorage();
			}
		}
	},
	methods: {
		isSelected(row: SaleRow):boolean {
			return this.state.selectedRow == row;
		},
		async send(){
			this.state.getSaleConfig();
			if (this.state.sale.ID != 0) {
				this.state.sale = this.detachFromSavedSale(this.state.sale);
			}
			let shouldShowRefundModal = this.state.sale.showCashierRefundModal();
			let done = await this.state.save();
			if(done && shouldShowRefundModal && AuthService.hasModule(MODULE.WINKELMODULE)){
				this.state.callBackTask = "print";
				this.state.ticketRefundModalOpen = true;
				this.state.saveModalData.preventClose = false;
			}else{
				if (!done) return;
				this.$wf.notify(this.$t("common.success").toString(), "success", 3000, "check");
				await this.complete();
			}
		},
		scrollTop() {
			this.scrollKey ++;
			const el:any = this.$refs.scrollBox;
			if (el){
				el.currentScrollTop = 0;
				el.$el.scrollTop = 0;
			}

		},
		scrollBottom() {
			const el = this.$el.querySelector(".scroll-box");
			if (el){
				setTimeout(() => el.scrollTop = (el.scrollHeight - 25), 250);
			}

		},
		openSettings(){
			this.openEditSaleSettings = true;
		},
		openDiverseModal(amount:number){
			this.diverseAmount = amount;
			this.openAddDiverse = true;
		},
		select(row: SaleRow){
			this.state.selectedRow = row;
		},
		detachFromSavedSale(sale: Sale): Sale {
			let json = sale.getJSON();
			json.ID = 0;
			json.FriendlyID = 0;
			json.ComputedFriendlyID = "";
			json.TotalOpen = 0;
			json.LastBankID = 0;
			json.History = [];
			json.InvoiceDate = new Date().toJSON();
			json.Rows = json.Rows.map((r: any) => ({...r, ID: 0, SaleID: 0}));
			let result = new Sale(json);
			result.calculateTotals();
			return result;
		},
		saveStorage(){
			let l =localStorage.getItem("cashier-store");
			if(l){
				let s = JSON.parse(l);
				s[this.activeCashier-1] = this.state.sale.ID == 0 ? new Sale(this.state.sale.getJSON()) : new Sale();
				localStorage.setItem("cashier-store",JSON.stringify(s));
			}
		},
		saveLastOrderToStorage(sale: Sale){
			try{
				localStorage.setItem("cashier-last-order",JSON.stringify(sale));
			}catch(err){
				console.error(err);
			}
		},
		async initCashierStorage(){
			const s = new Sale();
			let cashierStorage = [s,s,s];
			await localStorage.setItem("cashier-store",JSON.stringify(cashierStorage));
			this.storage = cashierStorage;
		},
		async fetchCashierFromStorage(){
			this.fetching = true;
			let l = await localStorage.getItem("cashier-store");
			if(l){
				this.storage = JSON.parse(l);
			}
			let a = this.storage[this.activeCashier-1];
			if(a.Rows.length && !a.ID){
				this.state.sale = new Sale(a);
			}else{
				this.state.sale = new Sale();
			}
			this.$emit("init");
			this.fetching = false;
		},
		async complete(){
			this.state.ticketRefundModalOpen = false;
			let sale = this.state.sale;
			let task = this.state.runCallbackTask();
			this.resetSale();
			this.saveLastOrderToStorage(sale);
			await task;
		},
		resetSale(){
			this.state.callBackTask = "";
			this.state.sale = new Sale();
			this.storage[this.activeCashier-1] = new Sale();
			this.saveStorage();
			this.scrollTop();
			this.$emit("init");
		},
		printHumanFloat(val:number):string{
			return printHumanFloat(val);
		}
	},
	async mounted(){
		this.$emit("state",this.state);
	},
	async created(){
		let c = await UserConfigService.getCashierSettings();
		this.displayID = c.ConnectedDisplay;
		let l = await localStorage.getItem("cashier-store");
		if(l){
			this.storage = JSON.parse(l);
		}else{
			await this.initCashierStorage();
		}
		this.fetchCashierFromStorage();
	},
	components: {
		AppCashierSaleSettings,
		AppCashierKeyPad,
		AppCashierAddDiverse,
		AppTicketRefundModal
	},
	i18nEx: {
		componentPrefix: "components.sales.Cashier"
	},
});
